import { useEffect, useState, MouseEvent, useContext } from 'react'
import parse from 'html-react-parser'
import { FragmentProps, FragmentType } from '../../../interfaces/Publication';
import { ReferencesContext } from '../../../context';

const ARTICLE = ({ fragment, openButtons, setOpenButtons }: FragmentProps) => {

    const [text, setText] = useState<string>("")
    const { addNewReference } = useContext(ReferencesContext)

    useEffect(() => {

        let theText = fragment.text
        if (theText) {

            theText = theText.replaceAll("<table", "<table class='table'")
            theText = theText.replaceAll("<th>", "<th class='table__th'>")
            theText = theText.replaceAll("<button", "<button class='reference' ")
            theText = theText.replaceAll("</table>", "<tfoot><tr><td colspan='100'></td></tr></tfoot></table>");
            // theText = theText.replaceAll("span", "span class='author'")

            setText(theText)
        }
    }, [fragment])

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        const target = event.target as HTMLButtonElement;
        if (target.tagName === 'BUTTON') {
            let content = target.dataset.content ? target.dataset.content : null
            let url = target.dataset.destination ? target.dataset.destination : null

            if (content) {
                addNewReference({ content, url });
                setOpenButtons({
                    ...openButtons,
                    optAuthor: false,
                    optConfig: false,
                    optFileDoc: false,
                    optHelp: false,
                    optIndex: false,
                    optNotes: false,
                    optReviews: false,
                    optReferences: true
                });
            }
        }
    };

    return (
        <>
            {/* <p>ESTE ES UN ARTICULO</p> */}

            {
                fragment.urlObj ?
                    <div className="header__actions">
                        <a className="btn btn-alt-primary" href={fragment.urlObj} target='_blank'>
                            <span className="btn__icon"><i className="icon icon-vpro-sec-tech-sheet"></i></span>
                            <span className="btn__label">Ver ficha técnica</span>
                        </a>
                    </div>
                    : null
            }

            <h3 style={{ display: fragment.title && fragment.type !== FragmentType.TABLE ? 'block' : 'none', margin: '20px 0px' }}>{typeof fragment.title === 'string' ? parse(fragment.title) : null}</h3>
            {
                fragment.subtitle ?
                    <h4 style={{ display: fragment.subtitle && fragment.type !== FragmentType.TABLE ? 'block' : 'none', margin: '20px 0px' }}>{typeof fragment.subtitle === 'string' ? parse(fragment.subtitle) : null}</h4>
                    : null
            }

            {
                fragment.autor ?
                    <div className="authors">
                        <span className="authors__title">Autores</span>
                        <ul className="authors__list unstyled-list">
                            <li className="authors__item">
                                {typeof fragment.autor === 'string' ? parse(fragment.autor) : null}
                            </li>
                        </ul>
                    </div>
                    : null
            }

            <div className='p-container gcontent'>
                {/* {text?parse(text):null}   */}
                {text ? <div className='iframe-wrapper' dangerouslySetInnerHTML={{ __html: text }} onClick={handleClick}></div> : null}

            </div>

            { fragment.creditos && (
                <section className="credits-article" aria-label="creditos del artículo">
                    <h5 className="credits-article__title">Créditos</h5>
                    <ul className="credits-article__list">
                        <li className='credits-article__list-item'>{typeof fragment.creditos === 'string' ? parse(fragment.creditos) : null}</li>
                    </ul>
                </section>
            )}
        </>
    )

}

export default ARTICLE